import React from 'react'
import { createRoot } from 'react-dom/client'
// import 'antd-mobile/dist/antd-mobile.css'
import App from './App'
// import { createStore } from 'redux'
import { Provider } from 'react-redux'
// import rootReducer from './redux/reducers'
import registerServiceWorker from './registerServiceWorker'

import store from '@/redux'

console.log(',lllllllll');


const container = document.getElementById('root')
const root = createRoot(container)
root.render(
  <Provider store={store}>
    <App />
  </Provider>
)
registerServiceWorker()
